<template>
  <div id="form" class="form">
    <div class="inner">
      <div class="form-head">
        <h2>Enquire today</h2>
        <p>
          Please
          {{ misc && misc.doncaster_telephone ? "contact us on " + misc.doncaster_telephone + " or " : "" }}complete our
          simple enquiry form and we will get back to you.
        </p>
      </div>
      <div class="form-body">
        <div class="form-row">
          <input class="half txt" placeholder="Name" type="text" v-model="form.name" />
          <input class="half txt" placeholder="Email" type="email" v-model="form.email" />
        </div>
        <div class="form-row">
          <input class="half txt" placeholder="Telephone" type="tel" v-model="form.tel" />
          <input
            class="half txt"
            :placeholder="isProperty ? 'Development' : 'Address'"
            type="text"
            v-model="form.address"
          />
        </div>
        <div class="form-row">
          <textarea class="txt" placeholder="Message" v-model="form.message"></textarea>
        </div>
        <div class="form-row">
          <span class="success" v-show="emailsuccess">Thanks, your request has been sent!</span>
          <span class="error" v-show="emailerror">{{ errormessage }}</span>
          <button @click="sendEmail">Send message</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import api from "@/services/api"

export default {
  props: ["modal"],
  computed: {
    ...mapState(["misc", "page"]),
    ...mapGetters(["isProperty"])
  },
  data: function() {
    return {
      emailsuccess: false,
      emailerror: false,
      errormessage: "",
      form: {},
      initial_values: {}
    }
  },
  created: function() {
    this.form = JSON.parse(JSON.stringify(this.initial_values))

    if (this.isProperty) this.form.address = [this.page.street, this.page.area].join(", ")
  },
  methods: {
    sendEmail: function() {
      this.emailsuccess = false
      this.emailerror = false

      if (!this.form.name || !this.form.email || !this.form.message) {
        this.errormessage = "Please fill in all fields, thanks!"
        this.emailerror = true
        return false
      }

      var content = `The following message has been sent from the website:<br /><br />`

      content += `Name: ${this.form.name}<br />
                  Email: ${this.form.email}<br />`

      if (this.form.tel) content += `Telephone: ${this.form.tel}<br />`
      if (this.form.address) content += `${this.isProperty ? "Property" : "Address"}: ${this.form.address}<br />`

      content += `Message: ${this.form.message}<br />`

      var subject = "Enquiry from the website"
      if (this.modal) subject = "Valuation request from the website"

      api
        .sendEmail(subject, content)
        .then(() => {
          this.emailsuccess = true
          this.form = JSON.parse(JSON.stringify(this.initial_values))
        })
        .catch(() => {
          this.errormessage = "There has been an error submiting your message"
          this.emailerror = true
        })
    }
  }
}
</script>

<style scoped>
.form {
  text-align: center;
  padding-bottom: 10rem;
  font-size: 1.8rem;
  background: #f7f7f7;
}

.form.alt {
  padding-top: 5rem;
}

.form-head {
  text-align: center;
  padding: 6rem 3% 3rem 3%;
}

.form.alt .form-head {
  padding-top: 2rem;
}

.form h2 {
  font-weight: normal;
  color: #455c6e;
  font-size: 4rem;
}

.txt {
  border: 0;
  width: 48%;
  margin: 1rem 0;
  padding: 1rem 1.5rem;
  font-size: 1.5rem;
  border: 3px solid #f5f5f5;
  float: left;
}

.txt:first-child {
  margin-right: 4%;
}

textarea.txt {
  width: 100%;
  margin: 1rem 0%;
  height: 8rem;
  margin-right: 0 !important;
}

button {
  display: inline-block;
  background: #d1ae54;
  padding: 1rem 2rem;
  margin-top: 1rem;
  font-size: 1.5rem;
  border: 0;
  color: #455c6e;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
}

button i {
  margin-left: 0.5rem;
}

.success,
.error {
  clear: both;
}

.success {
  color: green;
}

.error {
  color: #cc0000;
}

@media screen and (max-width: 500px) {
  .txt {
    width: 100%;
  }
}
</style>
